import React from "react";

const ModalSkeleton = () => {
  return <div></div>;
};

export default ModalSkeleton;
